import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { AdminService } from 'app/admin/admin.service';
import { NofeshNirshamimReservation } from 'app/admin/interface/nofesh-nirshamim-reservation';
import { Router } from '@angular/router';
import { IReservation } from 'app/admin/interface/ireservation';
import { IChangeReservation } from 'app/admin/interface/changeReservation';
import { UserMessagesService } from 'app/shared/user-messages/user-messages.service';
import { SpinnerService } from 'app/shared/spinner/spinner.service';
import { MatDialogConfig, MatDialog } from '@angular/material';
import { ConfirmDialogComponent } from 'app/shared/dialog/confirm-dialog/confirm-dialog.component';
import { ConfirmService } from 'app/shared/dialog/confirm.service';
import { ResultOfOperation } from 'app/shared/model/result-of-operation.model';


interface IKeyValue
{
  key: number;
  value: string;
}


@Component({
  selector: 'app-hamtana-or-bitul',
  templateUrl: './hamtana-or-bitul.component.html',
  styleUrls: ['./hamtana-or-bitul.component.css']
})
export class HamtanaOrBitulComponent implements OnInit {

  
  is_updated:boolean = false;
  is_Oved_Exists:boolean=false;
  ms_zehut_valid:boolean = true;
  is_oved_searched:boolean = false;
  isOvedMazminFound:boolean = false;
  nofshonimReservations: IReservation[] = [];
  selectedReservation : IReservation;
  changeReservation : IChangeReservation;

  constructor(private fb: FormBuilder,
              private _adminService: AdminService,
              private router: Router,
              private userMessages: UserMessagesService,
              private spinnerService: SpinnerService,
              private dialog: MatDialog,
              private confirmService : ConfirmService) { }

  ngOnInit() {
  }

  nofeshTitles: IKeyValue[] = [
    { key: 0, value: "בחר" }
  ];
  get ms_zehut_mazmin_error() { return this.nofesh.get('ms_zehut_mazmin'); }

  nofesh = this.fb.group({
    //main mazmin
    nofeshTitle:[0],
    ms_zehut_mazmin:['',Validators.compose([Validators.pattern("^[0-9]*$"), Validators.required])],
    tr_leida:[''],
    shem_prati:[''],
    shem_mishpacha:[''],
    ms_zehut:[''],
    phone:[''],
    nofesh_title:[''],
    nofesh_from:[''],
    nofesh_to:[''],
    is_hamtana:['']
  })

  displayNofesh()
  {
    this.selectedReservation = this.nofshonimReservations.find(reservation => reservation.nirshamim[0].id_nofesh == this.nofesh.value.nofeshTitle);
  }
  resetNofeshTitles()
  {
    this.nofeshTitles = [
      { key: 0, value: "בחר" }
    ];
    this.nofesh.value.nofeshTitle = 0;
  }
  searchNofeshForNirshamim()
  {
    this.userMessages.clearAll();
    this.resetNofeshTitles();
    this.nofshonimReservations = [];
      this.validateOvedmsZehut(this.nofesh.value.ms_zehut_mazmin);
      if(this.ms_zehut_valid)
      {
        this.spinnerService.showSpinner();
        this._adminService.GetNofeshAllNirshamimReservation(this.nofesh.value.ms_zehut_mazmin).subscribe(response => {
          if(response.isSuccess)
          {
            this.spinnerService.hideSpinner();
              this.nofshonimReservations = response.data as IReservation[];
              //Object.assign(this.nofshonimReservationsFiltered, this.nofshonimReservation);
              
              this.nofshonimReservations.forEach(reservation => {
                this.nofeshTitles.push({key: reservation.nirshamim[0].id_nofesh, value:reservation.nirshamim[0].nofesh_title});
              });
              
          }
          else
          {
            this.spinnerService.hideSpinner();
            this.is_oved_searched = true;
          }
        })
      }
  }


  validateOvedmsZehut(ms_zehut)
  {
    let valid_zehut = this.validatemsZehut(ms_zehut);
    if (valid_zehut) {
        this.ms_zehut_valid = true;
    }
    else {
        this.ms_zehut_valid = false;
        this.nofesh.patchValue({ ms_zehut: "" });
        return;
    }
  }
  validatemsZehut(value) {

    if (value.length == 0)
        return false;
    console.log(value.length);


    var result = true;
    var first8 = null;
    var cifratBikoret = null;
    try {
        if (value.length == 10)
            first8 = value.substring(0, 9);
        else {
            if (value.length == 9)
                first8 = "0" + value.substring(0, 8);
            else
                first8 = "00" + value.substring(0, 8);
        }
        cifratBikoret = value.substring(value.length - 1);
        var checkDigits = 0 * 1;
        var temp = 0;
        var i = 0;

        for (i = 1; i <= 9; i++) {
            temp = first8.charAt(i - 1);
            checkDigits = temp * 1 + checkDigits * 1;
            if ((i % 2) == 1) {
                checkDigits = temp * 1 + checkDigits * 1;
                if (temp > 4)
                    checkDigits = checkDigits * 1 - 9;
            }
        }
        checkDigits = (10 - checkDigits % 10) % 10;
        result = (checkDigits * 1 == cifratBikoret * 1);
    }
    catch (e) { result = false; }
    if (value == "0")
        result = false;
    return result;
}
onMsZehutSearchChange(value:string){
  this.is_oved_searched = false; 
}

hakpaza()
{
  this.changeReservation = new IChangeReservation();
  this.changeReservation.id_nofesh = this.selectedReservation.nirshamim[0].id_nofesh;
  this.changeReservation.ms_zehut_mazmin = this.selectedReservation.nirshamim[0].ms_zehut_mazmin;
  this.changeReservation.operationType = 2;
  this.spinnerService.showSpinner();
  this._adminService.changeReservation(this.changeReservation).subscribe(res => {
    if(res.isSuccess)
    {
      this.spinnerService.hideSpinner();
      this.userMessages.setSuccessMessage("ההזמנה הוקפצה בהצלחה");
    }
    else
    {
      this.spinnerService.hideSpinner();
      this.userMessages.setErrorMessage("בעיה בהקפצת הזמנה");
    }
  })
}
haavaraLeHamtana()
{
  this.changeReservation = new IChangeReservation();
  this.changeReservation.id_nofesh = this.selectedReservation.nirshamim[0].id_nofesh;
  this.changeReservation.ms_zehut_mazmin = this.selectedReservation.nirshamim[0].ms_zehut_mazmin;
  this.changeReservation.operationType = 1;
  this.spinnerService.showSpinner();
  this._adminService.changeReservation(this.changeReservation).subscribe(res => {
    if(res.isSuccess)
    {
      this.userMessages.setSuccessMessage("ההזמנה הועברה להמתנה בהצלחה");
      this.spinnerService.hideSpinner();
    }
    else
    {
      this.userMessages.setErrorMessage("בעיה בהעברת ההזמנה להמתנה");
      this.spinnerService.hideSpinner();
    }
  })
}
bitulNofesh()
{
  this.changeReservation = new IChangeReservation();
  this.changeReservation.id_nofesh = this.selectedReservation.nirshamim[0].id_nofesh;
  this.changeReservation.ms_zehut_mazmin = this.selectedReservation.nirshamim[0].ms_zehut_mazmin;
  this.changeReservation.operationType = 3;
  this.spinnerService.showSpinner();
  this._adminService.changeReservation(this.changeReservation).subscribe(res => {
    if(res.isSuccess)
    {
      this.userMessages.setSuccessMessage("ההזמנה בוטלה בהצלחה");
      this.spinnerService.hideSpinner();
    }
    else
    {
      this.userMessages.setErrorMessage("בעיה בביטול הזמנה");
      this.spinnerService.hideSpinner();
    }
  })
}

bitulNofeshDialog()
{
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
   
    dialogConfig.data = {title : "ביטול נופש ",text:"האם אתה בטוח שהינך רוצה לבטל את הנופש?"}
    let dialogRef = this.dialog.open(ConfirmDialogComponent,dialogConfig);
    let result: ResultOfOperation<object>;
    let confirmSubscription = this.confirmService.confirm$.subscribe((confirm:boolean) => {

      if(confirm)
      {
        this.changeReservation = new IChangeReservation();
        this.changeReservation.id_nofesh = this.selectedReservation.nirshamim[0].id_nofesh;
        this.changeReservation.ms_zehut_mazmin = this.selectedReservation.nirshamim[0].ms_zehut_mazmin;
        this.changeReservation.operationType = 3;
        this.spinnerService.showSpinner();
        this._adminService.changeReservation(this.changeReservation).subscribe(res => {
        result = res;
          if(res.isSuccess)
          {
            
            confirmSubscription.unsubscribe();
            dialogRef.close();
          }
          else
          {
            
          }
       })
      }
    })

    dialogRef.afterClosed().subscribe(_ => {
      if(result && result.isSuccess)
      {
        this.userMessages.setSuccessMessage("ההזמנה בוטלה בהצלחה");
        this.spinnerService.hideSpinner();
      }
      else if(result && !result.isSuccess)
      {
        this.userMessages.setErrorMessage("בעיה בביטול הזמנה");
        this.spinnerService.hideSpinner();
      }
      else
      {
        this.router.navigateByUrl("admin/nofesh-admin/hamtana-or-bitul");
        //this.userMessage.setErrorMessage("בעיה במחיקת נופשון, אנא נסה שוב מאוחר");
      }
    });
}
}
